export default __webpack_public_path__ + "static/compareItemImg4-6c4ba8ec33544b9d686028e071e520a0.png";